module.exports = __webpack_public_path__ + "img/192-philippines.9f40a72f.svg";